// extracted by mini-css-extract-plugin
export var between = "spreadSlider-module--between--MKkqF";
export var color = "spreadSlider-module--color--33IsS";
export var colorContainer = "spreadSlider-module--colorContainer--Fr8xa";
export var container = "spreadSlider-module--container--n3+76";
export var slideContainer = "spreadSlider-module--slideContainer--Yp2+f";
export var slideContainerTwo = "spreadSlider-module--slideContainerTwo--kgiqH";
export var slideLabel = "spreadSlider-module--slideLabel--RxCFm";
export var slider = "spreadSlider-module--slider--LagRn";
export var sliderValue = "spreadSlider-module--sliderValue--M1inY";